export default __webpack_public_path__ + "3314584ea2da7129bc978039fa20f80f.png";